import React, {useEffect, useState} from "react";
import logo from "assets/brand/logonew.png";
import {
    Button,
    FormGroup,
    Input
  } from "reactstrap";
import useGlobal from "store";
import {Elements } from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import AddCreditCardForm from "views/Account/AddCreditCardForm";

const FinishOnboarding = (props) => {

    const STRIPE_PUB_KEY = (process.env.NODE_ENV === "development") 
                ? "pk_test_51HJKijFFO6RzyUk0QbqXdf30FPXM1vgXFNiN0qQVaV3qkwyOG3THAkOgo37FrB5bJ4kbo2wTHUPXXSqrEchdxQJb000gu1tU8p" 
                : "pk_live_51HJKijFFO6RzyUk0Lc3OF1DUc1JtPb5W2txfKFU81wofrCyeBmbL9ipkvkstP7PgSvm2SrAoupK3OBD8jZey9QNH00j4WJcCa7";

    const stripePromise = loadStripe(STRIPE_PUB_KEY);

    const wrapperStyle = {
        position: "fixed",
        top: "0",
        right: "0",
        left: "0",
        bottom: "0",
        background: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        textAlign: "center",
        zIndex: "99999999"
    };

    const [response, actions] = useGlobal(
        state => state.response,
        actions => actions
      );
    
      const [user] = useGlobal(
        state => state.user
      );
    
      const [confirmPassword, setConfirmPassword] = useState('');
      const [errorMessage, setErrorMessage] = useState('');
    
      const [formState, setFormState] = useState({
          first_name: '',
          last_name: '',
          password: ''
      });
    
      useEffect(() => {
        if(!user) {
          return;
        }
        setFormState({
          first_name: user.first_name,
          last_name: user.last_name
        });
      }, [user]);
    
      const handleInputChange = (event) => {
          const target = event.target;
          const value = target.type === 'checkbox' ? target.checked : target.value;
          const name = target.name;
          let formFields = { ...formState };
          formFields[name] = value;
          setFormState(formFields);
      }
    
      const saveProfile = () => {
          console.log('save profile', formState);
          if(formState.password && formState.password !== confirmPassword) {
              setErrorMessage('Passwords do not match!');
              return;
          }
          actions.userActions.updateUser(formState);
      }
    
      useEffect(() => {
          if(!response || response.type !== "userupdated") {
              return;
          }
          //actions.notifierActions.notify('Profile saved!', 'success', 'br');
      }, [response]);

    return (
        <div style={wrapperStyle}>
            <img alt="streempay logo" style={{width: "200px", margin: "20px auto"}} src={logo} />
            <h5>Let's finish setting up your account...</h5>
            { errorMessage ? <p style={{color: "red"}}>{errorMessage}</p> : <></> }
            <div style={{maxWidth: "90%", width: "400px", margin: "10px auto", background: "white", textAlign: "left"}}>
                { (!user.has_password || !user.first_name || !user.last_name) ?
                    <>
                    <FormGroup>
                        <label>First Name</label>
                        <Input type="text" placeholder="First Name" name="first_name" onChange={handleInputChange} value={formState.first_name || ''} />
                    </FormGroup>
                    <FormGroup>
                        <label>Last Name</label>
                        <Input type="text" placeholder="Last Name" name="last_name" onChange={handleInputChange} value={formState.last_name || ''} />
                    </FormGroup>
                    <FormGroup>
                        <label>New Password</label>
                        <Input type="password" placeholder="New Password" name="password" onChange={handleInputChange} value={formState.password || ''} />
                    </FormGroup>
                    <FormGroup>
                        <label>Confirm Password</label>
                        <Input type="password" placeholder="Confirm Password" name="confirm_password" onChange={(e) => setConfirmPassword(e.target.value)} value={confirmPassword} />
                    </FormGroup>

                    
                    <Button
                          block
                          color="primary"
                          size="lg"
                          type="button"
                          className="mb-3 mt-3 btn-round"
                          onClick={() => saveProfile()}
                        >
                          OK
                        </Button>
                    </>
                : <>
                    <Elements stripe={stripePromise}>
                        <AddCreditCardForm></AddCreditCardForm>
                    </Elements>
                </> }
            </div>
        </div>
    );
}
export default FinishOnboarding;